import { render, staticRenderFns } from "./ProductAction.vue?vue&type=template&id=275c6b5c&scoped=true&"
import script from "./ProductAction.vue?vue&type=script&lang=js&"
export * from "./ProductAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275c6b5c",
  null
  
)

export default component.exports